import { MenuItem, MenuType } from "@/components/Menu/menu.interface";
import { NEXT_PUBLIC_CDN_URL } from "@/libs/constants/auth";
import routes from "@/helpers/router";

const menuListData: MenuItem[] = [
  {
    label: "Preconception",
    type: "category",
    slug: "preconception",
    iconURL: `${NEXT_PUBLIC_CDN_URL}/images/momverse/menu/preconception.png`,
    children: [
      {
        label: "Preconception Care",
        type: "pillar",
        slug: "preconception-care",
        iconURL: `${NEXT_PUBLIC_CDN_URL}/images/momverse/menu/preconception-care.png`,
      },
      {
        label: "How to get pregnant",
        type: "pillar",
        slug: "how-to-get-pregnant",
        iconURL: `${NEXT_PUBLIC_CDN_URL}/images/momverse/menu/get-pregnant.png`,
      },
      {
        label: "Ovulation",
        type: "pillar",
        slug: "ovulation",
        iconURL: `${NEXT_PUBLIC_CDN_URL}/images/momverse/menu/ovulation.png`,
      },
      {
        label: "Infertility",
        type: "pillar",
        slug: "infertility",
        iconURL: `${NEXT_PUBLIC_CDN_URL}/images/momverse/menu/infertility.png`,
      },
    ],
  },
  {
    label: "Pregnancy",
    type: "category",
    slug: "pregnancy",
    iconURL: `${NEXT_PUBLIC_CDN_URL}/images/momverse/menu/pregnancy.png`,
    children: [
      {
        label: "First Trimester",
        type: "pillar",
        slug: "first-trimester",
        iconURL: `${NEXT_PUBLIC_CDN_URL}/images/momverse/menu/trimester1.png`,
        children: [
          {
            label: "Month 1",
            type: "cluster",
            clusterType: "month",
            slug: "pregnancy-month-1",
            iconURL: `${NEXT_PUBLIC_CDN_URL}/images/momverse/menu/month-1.png`,
            children: [
              { label: "Week 1", type: "cluster", clusterType: "week", slug: "pregnancy-week-1" },
              { label: "Week 2", type: "cluster", clusterType: "week", slug: "pregnancy-week-2" },
              { label: "Week 3", type: "cluster", clusterType: "week", slug: "pregnancy-week-3" },
              { label: "Week 4", type: "cluster", clusterType: "week", slug: "pregnancy-week-4" },
            ],
          },
          {
            label: "Month 2",
            type: "cluster",
            clusterType: "month",
            slug: "pregnancy-month-2",
            iconURL: `${NEXT_PUBLIC_CDN_URL}/images/momverse/menu/month-2.png`,
            children: [
              { label: "Week 5", type: "cluster", clusterType: "week", slug: "pregnancy-week-5" },
              { label: "Week 6", type: "cluster", clusterType: "week", slug: "pregnancy-week-6" },
              { label: "Week 7", type: "cluster", clusterType: "week", slug: "pregnancy-week-7" },
              { label: "Week 8", type: "cluster", clusterType: "week", slug: "pregnancy-week-8" },
            ],
          },
          {
            label: "Month 3",
            type: "cluster",
            clusterType: "month",
            slug: "pregnancy-month-3",
            iconURL: `${NEXT_PUBLIC_CDN_URL}/images/momverse/menu/month-3.png`,
            children: [
              { label: "Week 9", type: "cluster", clusterType: "week", slug: "pregnancy-week-9" },
              { label: "Week 10", type: "cluster", clusterType: "week", slug: "pregnancy-week-10" },
              { label: "Week 11", type: "cluster", clusterType: "week", slug: "pregnancy-week-11" },
              { label: "Week 12", type: "cluster", clusterType: "week", slug: "pregnancy-week-12" },
            ],
          },
        ],
      },
      {
        label: "Second Trimester",
        type: "pillar",
        slug: "second-trimester",
        iconURL: `${NEXT_PUBLIC_CDN_URL}/images/momverse/menu/trimester2.png`,
        children: [
          {
            label: "Month 4",
            type: "cluster",
            clusterType: "month",
            slug: "pregnancy-month-4",
            iconURL: `${NEXT_PUBLIC_CDN_URL}/images/momverse/menu/month-4.png`,
            children: [
              { label: "Week 13", type: "cluster", clusterType: "week", slug: "pregnancy-week-13" },
              { label: "Week 14", type: "cluster", clusterType: "week", slug: "pregnancy-week-14" },
              { label: "Week 15", type: "cluster", clusterType: "week", slug: "pregnancy-week-15" },
              { label: "Week 16", type: "cluster", clusterType: "week", slug: "pregnancy-week-16" },
            ],
          },
          {
            label: "Month 5",
            type: "cluster",
            clusterType: "month",
            slug: "pregnancy-month-5",
            iconURL: `${NEXT_PUBLIC_CDN_URL}/images/momverse/menu/month-5.png`,
            children: [
              { label: "Week 17", type: "cluster", clusterType: "week", slug: "pregnancy-week-17" },
              { label: "Week 18", type: "cluster", clusterType: "week", slug: "pregnancy-week-18" },
              { label: "Week 19", type: "cluster", clusterType: "week", slug: "pregnancy-week-19" },
              { label: "Week 20", type: "cluster", clusterType: "week", slug: "pregnancy-week-20" },
              { label: "Week 21", type: "cluster", clusterType: "week", slug: "pregnancy-week-21" },
            ],
          },
          {
            label: "Month 6",
            type: "cluster",
            clusterType: "month",
            slug: "pregnancy-month-6",
            iconURL: `${NEXT_PUBLIC_CDN_URL}/images/momverse/menu/month-6.png`,
            children: [
              { label: "Week 22", type: "cluster", clusterType: "week", slug: "pregnancy-week-22" },
              { label: "Week 23", type: "cluster", clusterType: "week", slug: "pregnancy-week-23" },
              { label: "Week 24", type: "cluster", clusterType: "week", slug: "pregnancy-week-24" },
              { label: "Week 25", type: "cluster", clusterType: "week", slug: "pregnancy-week-25" },
              { label: "Week 26", type: "cluster", clusterType: "week", slug: "pregnancy-week-26" },
            ],
          },
        ],
      },
      {
        label: "Third Trimester",
        type: "pillar",
        slug: "third-trimester",
        iconURL: `${NEXT_PUBLIC_CDN_URL}/images/momverse/menu/trimester3.png`,
        children: [
          {
            label: "Month 7",
            type: "cluster",
            clusterType: "month",
            slug: "pregnancy-month-7",
            iconURL: `${NEXT_PUBLIC_CDN_URL}/images/momverse/menu/month-7.png`,
            children: [
              { label: "Week 27", type: "cluster", clusterType: "week", slug: "pregnancy-week-27" },
              { label: "Week 28", type: "cluster", clusterType: "week", slug: "pregnancy-week-28" },
              { label: "Week 29", type: "cluster", clusterType: "week", slug: "pregnancy-week-29" },
              { label: "Week 30", type: "cluster", clusterType: "week", slug: "pregnancy-week-30" },
            ],
          },
          {
            label: "Month 8",
            type: "cluster",
            clusterType: "month",
            slug: "pregnancy-month-8",
            iconURL: `${NEXT_PUBLIC_CDN_URL}/images/momverse/menu/month-8.png`,
            children: [
              { label: "Week 31", type: "cluster", clusterType: "week", slug: "pregnancy-week-31" },
              { label: "Week 32", type: "cluster", clusterType: "week", slug: "pregnancy-week-32" },
              { label: "Week 33", type: "cluster", clusterType: "week", slug: "pregnancy-week-33" },
              { label: "Week 34", type: "cluster", clusterType: "week", slug: "pregnancy-week-34" },
              { label: "Week 35", type: "cluster", clusterType: "week", slug: "pregnancy-week-35" },
            ],
          },
          {
            label: "Month 9",
            type: "cluster",
            clusterType: "month",
            slug: "pregnancy-month-9",
            iconURL: `${NEXT_PUBLIC_CDN_URL}/images/momverse/menu/month-9.png`,
            children: [
              { label: "Week 36", type: "cluster", clusterType: "week", slug: "pregnancy-week-36" },
              { label: "Week 37", type: "cluster", clusterType: "week", slug: "pregnancy-week-37" },
              { label: "Week 38", type: "cluster", clusterType: "week", slug: "pregnancy-week-38" },
              { label: "Week 39", type: "cluster", clusterType: "week", slug: "pregnancy-week-39" },
              { label: "Week 40", type: "cluster", clusterType: "week", slug: "pregnancy-week-40" },
            ],
          },
        ],
      },
      {
        label: "Labour & Delivery",
        type: "pillar",
        slug: "labour-and-delivery",
        iconURL: `${NEXT_PUBLIC_CDN_URL}/images/momverse/menu/labour-&-delivery.png`,
      },
      {
        label: "Premature Labour",
        type: "pillar",
        slug: "premature-labour",
        iconURL: `${NEXT_PUBLIC_CDN_URL}/images/momverse/menu/premature-labour.png`,
      },
      {
        label: "Abnormal Labour",
        type: "pillar",
        slug: "abnormal-child-delivery-labour",
        iconURL: `${NEXT_PUBLIC_CDN_URL}/images/momverse/menu/abnormal-labour.png`,
      },
    ],
  },
  {
    label: "Postpartum",
    type: "category",
    slug: "postpartum",
    iconURL: `${NEXT_PUBLIC_CDN_URL}/images/momverse/menu/postpartum.png`,
    children: [
      {
        label: "Breastfeeding & Formula",
        type: "pillar",
        slug: "breastfeeding-and-formula",
        iconURL: `${NEXT_PUBLIC_CDN_URL}/images/momverse/menu/breastfeeding.png`,
      },
      {
        label: "Postpartum mental health",
        type: "pillar",
        slug: "postpartum-mental-health",
        iconURL: `${NEXT_PUBLIC_CDN_URL}/images/momverse/menu/premature-labour.png`,
      },
      {
        label: "Abortion",
        type: "pillar",
        slug: "abortion",
        iconURL: `${NEXT_PUBLIC_CDN_URL}/images/momverse/menu/abortion.png`,
      },
      {
        label: "Miscarriage",
        type: "pillar",
        slug: "miscarriage",
        iconURL: `${NEXT_PUBLIC_CDN_URL}/images/momverse/menu/miscarriage.png`,
      },
    ],
  },
  {
    label: "Newborn & Infant",
    type: "category",
    slug: "newborn-and-infant",
    iconURL: `${NEXT_PUBLIC_CDN_URL}/images/momverse/menu/newborn-&-infant.png`,
    children: [
      {
        label: "Newborn Care",
        type: "pillar",
        slug: "newborn-care",
        iconURL: `${NEXT_PUBLIC_CDN_URL}/images/momverse/menu/newborn-care.png`,
      },
      {
        label: "Baby poop",
        type: "pillar",
        slug: "baby-poop",
        iconURL: `${NEXT_PUBLIC_CDN_URL}/images/momverse/menu/baby-poop.png`,
      },
      {
        label: "Baby Vaccination",
        type: "pillar",
        slug: "baby-vaccination",
        iconURL: `${NEXT_PUBLIC_CDN_URL}/images/momverse/menu/baby-vaccination.png`,
      },
      {
        label: "Baby Food",
        type: "pillar",
        slug: "baby-food",
        iconURL: `${NEXT_PUBLIC_CDN_URL}/images/momverse/menu/baby-food.png`,
      },
      {
        label: "Baby Sleep",
        type: "pillar",
        slug: "baby-sleep",
        iconURL: `${NEXT_PUBLIC_CDN_URL}/images/momverse/menu/baby-sleep.png`,
      },
      {
        label: "Baby Names",
        type: "pillar",
        slug: "baby-names",
        iconURL: `${NEXT_PUBLIC_CDN_URL}/images/momverse/menu/baby-names.png`,
      },
      {
        label: "Infant Development",
        type: "pillar",
        slug: "infant-development",
        iconURL: `${NEXT_PUBLIC_CDN_URL}/images/momverse/menu/infant-development.png`,
        children: [
          {
            label: "Month 1",
            type: "cluster",
            clusterType: "infant",
            slug: "1-month-old-baby",
            iconURL: `${NEXT_PUBLIC_CDN_URL}/images/momverse/menu/month-1.png`,
          },
          {
            label: "Month 2",
            type: "cluster",
            clusterType: "infant",
            slug: "2-month-old-baby",
            iconURL: `${NEXT_PUBLIC_CDN_URL}/images/momverse/menu/month-2.png`,
          },
          {
            label: "Month 3",
            type: "cluster",
            clusterType: "infant",
            slug: "3-month-old-baby",
            iconURL: `${NEXT_PUBLIC_CDN_URL}/images/momverse/menu/month-3.png`,
          },
          {
            label: "Month 4",
            type: "cluster",
            clusterType: "infant",
            slug: "4-month-old-baby",
            iconURL: `${NEXT_PUBLIC_CDN_URL}/images/momverse/menu/month-4.png`,
          },
          {
            label: "Month 5",
            type: "cluster",
            clusterType: "infant",
            slug: "5-month-old-baby",
            iconURL: `${NEXT_PUBLIC_CDN_URL}/images/momverse/menu/month-5.png`,
          },
          {
            label: "Month 6",
            type: "cluster",
            clusterType: "infant",
            slug: "6-month-old-baby",
            iconURL: `${NEXT_PUBLIC_CDN_URL}/images/momverse/menu/month-6.png`,
          },
          {
            label: "Month 7",
            type: "cluster",
            clusterType: "infant",
            slug: "7-month-old-baby",
            iconURL: `${NEXT_PUBLIC_CDN_URL}/images/momverse/menu/month-7.png`,
          },
          {
            label: "Month 8",
            type: "cluster",
            clusterType: "infant",
            slug: "8-month-old-baby",
            iconURL: `${NEXT_PUBLIC_CDN_URL}/images/momverse/menu/month-8.png`,
          },
          {
            label: "Month 9",
            type: "cluster",
            clusterType: "infant",
            slug: "9-month-old-baby",
            iconURL: `${NEXT_PUBLIC_CDN_URL}/images/momverse/menu/month-9.png`,
          },
          {
            label: "Month 10",
            type: "cluster",
            clusterType: "infant",
            slug: "10-month-old-baby",
            iconURL: `${NEXT_PUBLIC_CDN_URL}/images/momverse/menu/month-10.png`,
          },
          {
            label: "Month 11",
            type: "cluster",
            clusterType: "infant",
            slug: "11-month-old-baby",
            iconURL: `${NEXT_PUBLIC_CDN_URL}/images/momverse/menu/month-11.png`,
          },
          {
            label: "Month 12",
            type: "cluster",
            clusterType: "infant",
            slug: "12-month-old-baby",
            iconURL: `${NEXT_PUBLIC_CDN_URL}/images/momverse/menu/month-12.png`,
          },
        ],
      },
    ],
  },
];

const sortByChildren: (a: MenuItem, b: MenuItem) => number = (a, b) => {
  const aHasChildren = Array.isArray(a.children) && a.children.length > 0;
  const bHasChildren = Array.isArray(b.children) && b.children.length > 0;

  if (aHasChildren && !bHasChildren) {
    return -1;
  } else if (!aHasChildren && bHasChildren) {
    return 1;
  } else {
    return 0;
  }
};

const getMenuURL: (type: MenuType, slug: string) => string = (type, slug) => {
  if (!slug) {
    return "#";
  }

  switch (type) {
    case "category":
      return routes.category(slug);
    case "cluster":
      return routes.cluster(slug);
    case "pillar":
      return routes.pillar(slug);
    default:
      return "#";
  }
};

export { menuListData, sortByChildren, getMenuURL };
